import {format} from 'date-fns'

export function dateAccessor(d?: Date | null): string {
  return d !== null && d !== undefined ? format(d, 'MMM d, yyyy') : 'None'
}

export function booleanAccessor(b?: boolean | null): string {
  return b === true ? 'True' : 'False'
}
